import script from "./SourceSelectorSankey.vue?vue&type=script&setup=true&lang=js"
export * from "./SourceSelectorSankey.vue?vue&type=script&setup=true&lang=js"

import "./SourceSelectorSankey.vue?vue&type=style&index=0&id=5d0d5558&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d0d5558"]])

export default __exports__